const dev = process.env.NODE_ENV !== 'production';

export const API_URL_PREFIX = '/api';

export const LOG_LEVEL = dev ? 'DEBUG' : 'WARN';

export const CUSTOMERS_ROOT_PATH = '/';

const location = window.location;
export const SOCKET_HOST = dev ? 'localhost' : location.hostname;
export const SOCKET_PROTOCOL = location.protocol === 'http:' ? 'ws:' : 'wss:';
export const SOCKET_PATH = `${SOCKET_PROTOCOL}//${SOCKET_HOST}`;

// eslint-disable-next-line no-magic-numbers
export const HEARTBEAT_TIMEOUT    = 10 * 60 * 1000; // ms

export const TIME_OF_LONG_REQUEST = 500; // ms

export const NOTIFICATION_INFO_TIMEOUT = 10000;


export const START_EPISODE_AT = 3600000;

export const MAX_CLIP_DURATION = 300000; //ms  = 5min

export const CLIP_TYPE_CODE = 1;

export const CARTS_PAGE_SIZE = 15;


export const MUX_API_KEY = 'f667c6926368c7c3eadf61e8f';
export const GA_KEY = 'UA-101872229-1';

export const CLIP = { type: 'Clips', tk: 'clips' };
export const CAPTIONS_TYPE = { type: 'Captions', tk: 'captions' };

export const METADATA_TYPES = [
   { type: 'character', tk: 'metadata.characters' },
   { type: 'location',  tk: 'metadata.locations' },
   { type: 'action',    tk: 'metadata.actions' },
   { type: 'subject',   tk: 'metadata.subjects' },
   { type: 'tag',       tk: 'metadata.tags' }
];


export const QUERY_PROP_FIELDS = [
   { field: 'cc',          tk: 'query.dialog' },
   { field: 'desc',        tk: 'query.description' },
   { field: 'subjects',    tk: 'metadata.subjects' },
   { field: 'characters',  tk: 'metadata.characters' },
   { field: 'actions',     tk: 'metadata.actions' },
   { field: 'locations',   tk: 'metadata.locations' },
   { field: 'tags',        tk: 'metadata.tags' },
   { field: 'name',        tk: 'query.title' }
];

export const TIMEDATA_TYPES = [ CLIP, ...METADATA_TYPES ];

